module.exports = __webpack_public_path__ + "svg/rails.dd8233.svg";